import {required} from "vuelidate/lib/validators";  
const omalzemegrup = {
    data() { 
      return {   
        omalzemegrupData: { 
          Adi: "",
          Deleted: false,
          }, 
          FormDataType:{
            Adi:{FieldName:"Adi",Field:"input",FieldTitle:this.$t('omalzemegrup.AddEdit.Adi')},  
          } 
      }
    }, 
    validations:{ 
      FormData: {  
        Adi: { required },  
      }
 
  },
  created(){

  }
}
export default omalzemegrup